import { create } from "zustand";

export interface PDAResetStore {
  // 등록된 reset 함수들
  resetFunctions: Set<() => void>;
  
  // Reset 함수 등록
  registerReset: (resetFn: () => void) => () => void;
  
  // 모든 등록된 reset 함수 실행
  resetAll: () => void;
  
  // 모든 reset 함수 제거
  clearAll: () => void;
}

/**
 * PDA 화면 공통 Reset 관리 스토어
 * 각 화면의 reset 함수를 등록하고, 뒤로가기 시 일괄 초기화
 */
const usePDAResetStore = create<PDAResetStore>((set, get) => ({
  resetFunctions: new Set(),
  
  // Reset 함수 등록 (언마운트 시 자동 제거를 위한 cleanup 함수 반환)
  registerReset: (resetFn: () => void) => {
    const { resetFunctions } = get();
    resetFunctions.add(resetFn);
    set({ resetFunctions: new Set(resetFunctions) });
    
    // Cleanup 함수 반환 (언마운트 시 자동 제거)
    return () => {
      const current = get().resetFunctions;
      current.delete(resetFn);
      set({ resetFunctions: new Set(current) });
    };
  },
  
  // 모든 등록된 reset 함수 실행
  resetAll: () => {
    const { resetFunctions } = get();
    console.log("🔄 모든 PDA 상태 초기화 시작, 등록된 함수 수:", resetFunctions.size);
    resetFunctions.forEach((resetFn) => {
      try {
        resetFn();
      } catch (error) {
        console.error("❌ Reset 함수 실행 실패:", error);
      }
    });
    console.log("✅ 모든 PDA 상태 초기화 완료");
  },
  
  // 모든 reset 함수 제거
  clearAll: () => {
    set({ resetFunctions: new Set() });
  },
}));

export default usePDAResetStore;

